import { ClientDetailTabs } from 'stores/local/pages/ClientDetailPageStore/types';
import { FieldName } from 'stores/local/shared/lot/FiltersStore';

export const ROUTES = {
  root: {
    path: '/',
    create: () => '/',
  },
  login: {
    path: '/login',
    create: () => '/login',
  },
  registration: {
    path: '/registration',
    create: () => '/registration',
    setPassword: {
      path: '/registration/set_password',
      create: () => '/registration/set_password',
    },
  },
  recovery: {
    path: '/recovery',
    create: () => '/recovery',
    setPassword: {
      path: '/recovery/set_password',
      create: () => '/recovery/set_password',
    },
  },
  lk: {
    path: '/lk',
    create: () => '/lk',
    profile: {
      path: '/lk/profile',
      create: () => '/lk/profile',
    },
    accessManagement: {
      path: '/lk/access-management',
      employees: {
        path: 'employees',
        create: () => '/lk/access-management/employees',
      },
      divisions: {
        path: 'divisions',
        create: () => '/lk/access-management/divisions',
      },
      requests: {
        path: 'requests',
        create: () => '/lk/access-management/requests',
      },
    },
    clients: {
      path: '/lk/clients',
      create: () => '/lk/clients',
      detail: {
        path: '/lk/clients/:id',
        create: (id: number) => `/lk/clients/${id}`,
        createTab: (id: number, tab: ClientDetailTabs = ClientDetailTabs.leads) => `/lk/clients/${id}/${tab}`,
        leads: {
          path: ClientDetailTabs.leads,
          create: (id: number) => `/lk/clients/${id}/${ClientDetailTabs.leads}`,
        },
        meetings: {
          path: ClientDetailTabs.meetings,
          create: (id: number) => `/lk/clients/${id}/${ClientDetailTabs.meetings}`,
        },
        lots: {
          path: ClientDetailTabs.lots,
          create: (id: number) => `/lk/clients/${id}/${ClientDetailTabs.lots}`,
        },
        // TODO: Вернуть при разработке «История обращений».
        // appealsHistory: {
        //   path: ClientDetailTabs.appealsHistory,
        //   create: (id: number) => `/lk/clients/${id}/${ClientDetailTabs.appealsHistory}`,
        // },
      },
    },
    leads: {
      path: '/lk/leads',
      create: () => '/lk/leads',
      detail: {
        path: '/lk/leads/:id',
        create: (id: number) => `/lk/leads/${id}`,
      },
    },
    projects: {
      path: '/lk/projects',
      create: () => '/lk/projects',
      detail: {
        path: '/lk/projects/:slug',
        create: (slug: string) => `/lk/projects/${slug}`,
        publication: {
          path: '/lk/projects/:projectSlug/publications/:slug',
          create: (projectSlug: string, slug: string) =>
            `/lk/projects/${projectSlug}/publications/${encodeURIComponent(slug)}`,
        },
        promotion: {
          path: '/lk/projects/:projectSlug/promotions/:slug',
          create: (projectSlug: string, slug: string) =>
            `/lk/projects/${projectSlug}/promotions/${encodeURIComponent(slug)}`,
        },
      },
    },
    lots: {
      path: '/lk/lot',
      create: () => '/lk/lot',
      createDetail: (projectId: number) => `/lk/lot?${FieldName.projects}=${projectId}`,
      detail: {
        path: '/lk/lot/:id',
        create: (id: number) => `/lk/lot/${id}`,
      },
      filters: {
        path: '/lk/lot/filters',
      },
    },
    favorites: {
      path: '/lk/favorites',
      create: () => '/lk/favorites',
    },
    meetings: {
      path: '/lk/meetings',
      create: () => '/lk/meetings',
    },
    about: {
      path: '/lk/about',
      create: () => '/lk/about',
    },
    documents: {
      path: '/lk/documents',
      create: () => '/lk/documents',
    },
    publications: {
      path: '/lk/publications',
      create: () => '/lk/publications',
      detail: {
        path: '/lk/publications/:slug',
        create: (slug: string) => `/lk/publications/${encodeURIComponent(slug)}`,
      },
    },
    promotions: {
      path: '/lk/promotions',
      create: () => '/lk/promotions',
      detail: {
        path: '/lk/promotions/:slug',
        create: (slug: string) => `/lk/promotions/${slug}`,
      },
    },
  },
} as const;
